<template>
  <div v-if="items.length">
    <div class="text-label-medium px-4 py-2 text-medium-emphasis">
      {{ subtitle }}
    </div>

    <DeepMenuListItem
      v-for="item in items"
      :key="item.key"
      :data-test-id="`integrations-${item.key}`"
      :item="item"
    />
  </div>
</template>

<script lang="ts" setup>
import { DeepMenuListItem } from '@deepcloud/deep-ui-lib'
import type { MenuItem } from '@deepcloud/deep-ui-lib'

defineProps({
  subtitle: {
    type: String,
    default: undefined,
  },
  items: {
    type: Array as PropType<MenuItem[]>,
    default: () => [],
  },
})
</script>
